document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector<HTMLElement>('[data-header]');
  const headerButton = document.querySelector('[data-header-button]');

  if (header && headerButton) {
    headerButton.addEventListener('click', () => {
      const open = header.getAttribute('data-open') === 'true';
      header.setAttribute('data-open', (!open).toString());
    });
  }

  // headerのdata-is-scroll-top属性の値を操作する
  const targetElement = document.querySelector<HTMLElement>(
    '[data-header-change-element]'
  );

  if (header && targetElement) {
    // 要素の上端位置を取得（ページ上端からの絶対位置）
    const getTargetTop = (): number => {
      return targetElement.getBoundingClientRect().top + window.scrollY;
    };

    let targetTop = getTargetTop();
    let ticking = false;

    // スクロール位置に基づいて属性を更新
    const updateHeaderState = (): void => {
      const scrollY = window.scrollY;
      const isScrolled = scrollY >= targetTop;
      header.dataset.isScrollTop = isScrolled ? 'false' : 'true';
    };

    // 初期状態を設定
    updateHeaderState();

    // スクロールイベント（requestAnimationFrameで最適化）
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateHeaderState();
          ticking = false;
        });
        ticking = true;
      }
    });

    // リサイズ時に位置を再計算
    window.addEventListener('resize', () => {
      targetTop = getTargetTop();
      updateHeaderState();
    });
  }

  // 言語ドロップダウンの開閉制御
  const closeAllLangDropdowns = (): void => {
    document
      .querySelectorAll('[data-lang-menu]')
      .forEach((menu) => menu.classList.add('hidden'));
    document
      .querySelectorAll('[data-lang-arrow]')
      .forEach((arrow) => arrow.classList.remove('rotate-180'));
  };

  const langDropdowns =
    document.querySelectorAll<HTMLElement>('[data-lang-dropdown]');
  langDropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('[data-lang-trigger]');
    const menu = dropdown.querySelector('[data-lang-menu]');
    const arrow = dropdown.querySelector('[data-lang-arrow]');

    if (trigger && menu) {
      trigger.addEventListener('click', () => {
        const isOpen = !menu.classList.contains('hidden');
        closeAllLangDropdowns();
        if (!isOpen) {
          menu.classList.remove('hidden');
          arrow?.classList.add('rotate-180');
        }
      });

      // 言語選択時に全ドロップダウンのボタンテキストを同期更新
      menu
        .querySelectorAll<HTMLAnchorElement>('a[data-stt-changelang]')
        .forEach((link) => {
          link.addEventListener('click', () => {
            document
              .querySelectorAll<HTMLElement>('[data-lang-trigger] span')
              .forEach((span) => {
                span.textContent = link.textContent;
              });
            closeAllLangDropdowns();
          });
        });
    }
  });

  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest('[data-lang-dropdown]')) {
      closeAllLangDropdowns();
    }
  });
});
